import { type FrontRoyalRootScope } from 'FrontRoyalAngular';
import getEnrollmentSidebarTodoGroups from 'Lessons/angularModule/scripts/stream/getEnrollmentSidebarTodoStuff';
import { ProgramTypeConfigs } from 'Program';
import { GraduationStatus, getGraduationStatus, getHasOfferOrIncludedOrCompleted } from 'Users';
import { type TodoItem } from './StudentDashboard.types';

export const shouldShowEnrollment = ($injector: ng.auto.IInjectorService) => {
    const user = $injector.get<FrontRoyalRootScope>('$rootScope').currentUser;
    if (!user) return false;

    const gradStatus = getGraduationStatus(user);

    // Reasons not to show the Enrollment sidebar box
    if (
        user.isAuditing ||
        !user.programType ||
        !ProgramTypeConfigs[user.programType].supportsEnrollmentSidebar(user.relevantCohort ?? null) ||
        !getHasOfferOrIncludedOrCompleted(user) ||
        (gradStatus && gradStatus !== GraduationStatus.pending) ||
        // user.needsToRegister should be false because we want registration to take
        // priority over enrollment. After they've registered, then show the enrollment sidebar
        user.needsToRegister ||
        !user.relevantCohort
    )
        return false;

    const [todoItems, _todoItemsByDueDate] = getEnrollmentSidebarTodoGroups($injector) as [
        TodoItem[],
        { [dueBy: string]: TodoItem[] },
    ];

    const todosToComplete = todoItems.filter(
        (todoItem: TodoItem) => todoItem.isVisible() && !todoItem.hasBeenCompleted(),
    );

    const onlyHasToCompleteIdVerification =
        todosToComplete.length === 1 && todosToComplete[0].name === 'todo_id_verify';

    // When the only thing to do is id verification, the enrollment box is unnecessary because we're already
    // showing the id verification box
    const hasTodosToShowInList = !!todosToComplete.length && !onlyHasToCompleteIdVerification;

    return hasTodosToShowInList;
};
